module.exports = __webpack_public_path__ + "img/FrameDDL.63f3fae7.png";